import { render, staticRenderFns } from "./Asignacion.vue?vue&type=template&id=93f07a60&"
import script from "./Asignacion.vue?vue&type=script&lang=js&"
export * from "./Asignacion.vue?vue&type=script&lang=js&"
import style0 from "./Asignacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports